var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wordcloud"}},[_vm._m(0),_c('vue-word-cloud',{staticStyle:{"margin":"auto","height":"50vh","width":"30vw"},attrs:{"words":_vm.hashtags,"color":function (ref) {
                      var weight = ref[1];

                      return '#3E31DD';
},"font-family":"Montserrat","spacing":2}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("..and you are a real trend lover! "),_c('br'),_vm._v(" These were your top hashtags")])}]

export { render, staticRenderFns }